module.exports = __webpack_public_path__ + "static/2-34ef12e3844650741af5adc0d1b82212.jpg";